module.exports = __webpack_public_path__ + "static/dsc-0496@3x-4aef166a6807192626b5592e5e12f111.png";